import type { CueCommandRequest } from '@/state/mutations/player/use-cue-command';

/**
 * Sequential nextMedia can skip live-context GET once perform-control WS seq advanced.
 * Go-back / jump lower the pointer — merge prefers the stale GET snapshot
 * (`preferGetCueSnapshotOverWs`), so Next stays on the pre-take item until GET replace.
 * Play-once insert overlays Current; GET must replace so rundown Current (red border) is the
 * take target. Next identity still comes from the resume overlay, not sequential `_lookahead:*`.
 */
export function shouldSkipCueCommandSuccessRefetch(params: {
  action?: CueCommandRequest['action'];
  cuePlayMode?: 'jump' | 'insert';
  seqAdvanced: boolean;
}): boolean {
  if (params.action === 'prevMedia' || params.action === 'playSegment') {
    return false;
  }
  if (params.action === 'playMedia' && (params.cuePlayMode === 'jump' || params.cuePlayMode === 'insert')) {
    return false;
  }
  return params.seqAdvanced;
}
